import React, {useEffect} from 'react';

import { withRouter } from 'react-router-dom';

function LogOut(props) {
  useEffect(() => {
      // window.location.href=process.env.REACT_APP_BACKEND_URL + '/logout';
      window.location.href='/app/logout';
  }, []);

  return (
    <>
    </>
  );
}

export default withRouter(LogOut);
